import React__default from 'react';
import classNames from 'classnames';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import { NvButton } from '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../constants/api.esm.js';
import styles from './SaveCustomPanelButton.module.esm.js';

var SaveCustomPanelButton = function (_a) {
    var _b;
    var concepts = _a.concepts, handleMultiTestSave = _a.handleMultiTestSave, isMultiTest = _a.isMultiTest, labelText = _a.labelText, productType = _a.productType;
    var toggleCustomModalForm = React__default.useContext(CartContext).toggleCustomModalForm;
    var onCloseModal = React__default.useCallback(function (saved) {
        if (saved === void 0) { saved = false; }
        if (saved && handleMultiTestSave && isMultiTest) {
            handleMultiTestSave();
        }
        toggleCustomModalForm({});
    }, [handleMultiTestSave, isMultiTest]);
    var onOpenModal = React__default.useCallback(function () {
        toggleCustomModalForm({ saveCustomPanelModalProps: { concepts: concepts, onClose: onCloseModal, productType: productType } });
    }, [concepts, productType]);
    return (React__default.createElement("div", { className: styles.customizablePanel },
        React__default.createElement(NvButton, { className: classNames(styles.saveButton, (_b = {}, _b[styles.multiTestSaveButton] = isMultiTest, _b)), dataTestId: "save-custom-panel-for-future-use-button", onClick: onOpenModal, size: "medium", variant: "secondary" }, labelText)));
};

export { SaveCustomPanelButton as default };
//# sourceMappingURL=SaveCustomPanelButton.esm.js.map
